export default __webpack_public_path__ + "static/media/a036-5.667f7d55.svg";